/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Portals_Org_HintInputs */

const cs_portals_org_hint = /** @type {(inputs: Portals_Org_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Porovnání inzerátů ${i?.name} se stavem publikace na portálech v celé kanceláři.`)
};

const en_portals_org_hint = /** @type {(inputs: Portals_Org_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compare ${i?.name} listings with portal publication state across the office.`)
};

/**
* | output |
* | --- |
* | "Compare {name} listings with portal publication state across the office." |
*
* @param {Portals_Org_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_org_hint = /** @type {((inputs: Portals_Org_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Org_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_org_hint(inputs)
	return cs_portals_org_hint(inputs)
});